module.exports = __webpack_public_path__ + "static/Moego-4c892d753f95c691b5b7c2dc7dd15f97.png";